import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import './assets/theme.scss'

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'small',
  form: {
    hideRequiredAsterisk: true
  }
})
Vue.prototype.$env = Vue.observable({
  domain: process.env.VUE_APP_DOMAIN,
  baseURL: process.env.VUE_APP_BASE_API,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
